// extracted by mini-css-extract-plugin
export var Portfolio = "index-module----portfolio--eudCI";
export var navigation = "index-module--navigation--1u83v";